import { Link } from "react-router-dom";
import { useCurrentUser } from "@/lib/auth";
import { formatRelative } from "@/lib/format";
import { Alert } from "@/components/ui/Alert";
import { useErrorLogSummary } from "@/hooks/useErrorLogSummary";

export function AdminHealthStatusCard() {
  const { user } = useCurrentUser();
  // Geteilter Store: nutzt denselben Fetch/Timer wie der Header-Indicator.
  const { summary, isAdmin } = useErrorLogSummary(user);

  if (!isAdmin) return null;

  const status = summary?.status ?? "ok";
  const hasErrors = (summary?.open_count ?? 0) > 0;

  return (
    <section className="md:col-span-2 xl:col-span-3">
      {hasErrors ? (
        <Alert
          variant={status === "kritisch" ? "error" : "warning"}
          title={status === "kritisch" ? "Kritische Server-Fehler erkannt" : "Server-Fehler erkannt"}
        >
          <p>
            {summary?.open_count === 1 ? "1 Fehlertyp" : `${summary?.open_count} Fehlertypen`} mit{" "}
            {summary?.total_occurrences} Vorkommen
            {summary?.newest_at ? ` · zuletzt ${formatRelative(summary.newest_at)}` : ""}.
          </p>
          <Link
            to="/admin/admin-area"
            className="mt-2 inline-block text-sm font-medium text-accent underline-offset-2 hover:underline"
          >
            Details im Admin-Bereich ansehen →
          </Link>
        </Alert>
      ) : (
        <Alert variant="success" title="App-Status">
          Keine offenen Server-Fehler im Log.{" "}
          <Link to="/admin/admin-area" className="font-medium text-accent underline-offset-2 hover:underline">
            Vollständigen Status ansehen
          </Link>
        </Alert>
      )}
    </section>
  );
}
